import * as React from "react";
import type { SVGProps } from "react";
const SvgCockpit = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2 2h17v5.755A8 8 0 1 1 6.252 16H2v-4h2v2h2a8 8 0 0 1 11-7.418V4H4v6H2zm12 6a6 6 0 1 0 0 12 6 6 0 0 0 0-12m3.756 2.723a1 1 0 0 1-.101 1.41l-1.695 1.468q.04.194.04.399a2 2 0 1 1-1.365-1.897l1.71-1.481a1 1 0 0 1 1.41.1"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgCockpit;
